<div class="place-section-container">

  <div class="place-section-container-inner">
      <div class="place-section-content">
        <p class="big-font">Место проведения</p>
        <p class="info-title">“Витязь Арена”</p>
        <p class="info-text">
          Адрес: ул. Кирова, 63 А, Подольск, Московская обл., 142117
        </p>
        <p class="info-text">
          Между Москвой и ареной «Витязь» расстояние составляет примерно 30-35 километров. Чтобы добраться, можно воспользоваться личным автомобилем, поехав по трассе М-10 (или по другим маршрутам через Московскую область), либо воспользоваться автобусом или такси.
        </p>
        <p class="info-text">
          У катка есть парковка, а рядом расположена гостиница «Подмосковье», где можно комфортно остановиться.
        </p>
      </div>
  </div>
  <div class="map-container">
    <app-yandex-map/>
  </div>
</div>
